import dayjs from 'dayjs';
import { IUser } from 'app/shared/model/user.model';
import { Status } from 'app/shared/model/enumerations/status.model';
import { Nationality } from 'app/shared/model/enumerations/nationality.model';
import { BusinessDistrict } from 'app/shared/model/enumerations/business-district.model';
import { BusinessCity } from 'app/shared/model/enumerations/business-city.model';
import { BusinessProvince } from 'app/shared/model/enumerations/business-province.model';

export interface IFactChecking {
  id?: number;
  status?: keyof typeof Status | null;
  recordNumber?: string;
  createDate?: dayjs.Dayjs | null;
  recordDate?: dayjs.Dayjs | null;
  recordTime?: string | null;
  recordLocation?: string | null;
  foreignerFullName?: string;
  nationality?: keyof typeof Nationality;
  foreignerPassportNo?: string;
  workPosition?: string | null;
  workName?: string | null;
  employer?: string | null;
  relationToSubject?: string | null;
  businessLocationFound?: boolean | null;
  businessHouseNo?: string | null;
  businessMoo?: number | null;
  businessDistrict?: keyof typeof BusinessDistrict;
  businessCity?: keyof typeof BusinessCity;
  businessprovince?: keyof typeof BusinessProvince;
  businessLocationName?: string | null;
  businessBuilding?: string | null;
  businessDescription?: string | null;
  businessSignCorrect?: boolean | null;
  businessNotFoundReason?: string | null;
  applicantFound?: boolean | null;
  applicantWorkPosition?: string | null;
  applicantIncome?: number | null;
  applicantNotFoundReason?: string | null;
  thaiStaffDeclared?: number | null;
  thaiStaffFound?: number | null;
  thaiStaffList?: string | null;
  thaiStaffNotFound?: number | null;
  thaiStaffNotFoundReason?: string | null;
  inspectionEndTime?: string | null;
  remark?: number | null;
  inspectionPic1ContentType?: string | null;
  inspectionPic1?: string | null;
  inspectionPic2ContentType?: string | null;
  inspectionPic2?: string | null;
  inspectionPic3ContentType?: string | null;
  inspectionPic3?: string | null;
  inspectionPic4ContentType?: string | null;
  inspectionPic4?: string | null;
  officer1?: IUser | null;
  officer2?: IUser | null;
  officerRecorder?: IUser | null;
  officerInvestigation?: IUser | null;
}

export const defaultValue: Readonly<IFactChecking> = {
  businessLocationFound: false,
  businessSignCorrect: false,
  applicantFound: false,
};
